<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title class="va-card__title">
      <span>{{ 'FRONTEND.SALES_UI.ACCOUNT_DETAILS.LOCAL_TIME.TITLE' | translate }}</span>
      <ng-content select="[afterTitle]"></ng-content>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <ng-container *ngIf="shouldAddTimezone$ | async; else showTime">
      <a [routerLink]="editTimezoneUrl$ | async">
        + {{ 'FRONTEND.SALES_UI.ACCOUNT_DETAILS.LOCAL_TIME.ADD_TIMEZONE' | translate }}
      </a>
    </ng-container>
    <ng-template #showTime>
      <ng-container *ngIf="localTime$ | async as localTime; else reload">
        <span class="local-time">{{ localTime.time }}</span>
        <br />
        <span class="local-address">{{ localTime.address }}</span>
      </ng-container>
      <ng-template #reload>
        <sales-ui-async-text
          [loadFailed]="(success$ | async) === false"
          [loading]="loading$ | async"
          (retry)="retryLoading()"
        ></sales-ui-async-text>
      </ng-template>
    </ng-template>
  </mat-card-content>
</mat-card>
